import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var ArrowDownIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 14 7" }),
    React.createElement("path", { d: "M7 7a1 1 0 00.625-.219l5.781-4.625-1.25-1.562L7 4.72 1.844.6.594 2.162l5.781 4.625A1 1 0 007 7z" }))); };

export { ArrowDownIcon as default };
